<sw-modal
    :title="modalTitle"
    @modal-close="onCancel"
>
    <sw-container columns="1fr 1fr" gap="0 20px">
        <sw-text-field
            v-model="entity.name"
            required
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelName')"
        ></sw-text-field>

        <sw-single-select
            v-model:value="entity.defaultScope"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelDefaultScope')"
            :options="scopeOptions"
        ></sw-single-select>

        <sw-text-field
            v-model="entity.url"
            required
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelUrl')"
            :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.helpUrl')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.language"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelLanguage')"
            :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.helpLanguage')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.columnTerm"
            required
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelColumnTerm')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.columnSynonyms"
            required
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelColumnSynonyms')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.columnScope"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelColumnScope')"
            :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.helpColumnOptional')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.columnLanguage"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelColumnLanguage')"
            :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.helpColumnOptional')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.delimiter"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelDelimiter')"
        ></sw-text-field>

        <sw-text-field
            v-model="entity.enclosure"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelEnclosure')"
        ></sw-text-field>

        <sw-switch-field
            v-model:value="entity.active"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelActive')"
        ></sw-switch-field>

        <sw-number-field
            v-model:value="entity.position"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.labelPosition')"
        ></sw-number-field>
    </sw-container>

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>
